import { isContentMock } from '@src/services/community';
import contentMock from '@src/services/communityMock';
import { requestAPI } from '@src/utils/fetch';

/**
 * 헌혈요청 "돕겠습니다"(참여자) API — 상세 사이드바의 모집 현황/참여자 목록.
 * 백엔드: /api/v1/donation/{uuid}/helpers
 */

export interface DonationHelper {
  uuid: string;
  accountUuid: string;
  displayName: string;
  profileImageUrl: string | null;
  visitAt: string | null;
  status: 'PLEDGED' | 'RESERVED' | 'DONE' | 'CANCELED';
  createdAt: string;
}

export interface DonationProgress {
  requiredCount: number | null;
  fulfilledCount: number;
  iAmHelping: boolean;
  helpers: DonationHelper[];
}

const base = (donationUuid: string) =>
  `/api/v1/donation/${encodeURIComponent(donationUuid)}/helpers`;

const getProgress = async (donationUuid: string): Promise<DonationProgress> => {
  const { data } = await requestAPI().get(base(donationUuid));
  return data;
};

const help = async (
  donationUuid: string,
  visitAt?: string | null
): Promise<DonationProgress> => {
  const { data } = await requestAPI().post(base(donationUuid), {
    visitAt: visitAt ?? null,
  });
  return data;
};

const cancel = async (donationUuid: string): Promise<DonationProgress> => {
  const { data } = await requestAPI().delete(base(donationUuid));
  return data;
};

const realApi = { getProgress, help, cancel };

// 디자인 확인용 더미 모드(NEXT_PUBLIC_CONTENT_MOCK=true)면 참여자 API도 더미로 대체한다.
const donationHelperApi: typeof realApi = new Proxy(realApi, {
  get(target, prop: string) {
    if (isContentMock() && prop in contentMock) {
      return (contentMock as any)[prop];
    }
    return (target as any)[prop];
  },
});

export default donationHelperApi;
